export type Options = {
    /** If versions mismatches will discard the values */
    version?: number | string;
    debugging?: boolean;
    listenForUpdates?: boolean;
};

/** Versioned storage access */
export function getVersionedKey(
    key: string,
    version?: number | string | undefined,
) {
    if (version) {
        return `${key}-${version}`;
    }
    return key;
}

class Wrapper {
    storage: Storage;

    constructor(storage: Storage) {
        this.storage = storage;
    }

    // biome-ignore lint/suspicious/noExplicitAny: inherited from operator
    setItem(key: string, obj: any) {
        this.storage.setItem(key, JSON.stringify(obj));
        window.dispatchEvent(new StorageEvent(`local_storage_updated_${key}`));
    }

    getItem(key: string) {
        return JSON.parse(
            // TODO: improve the way we handle
            // null result from our storage
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            this.storage.getItem(key),
        );
    }

    removeItem(key: string) {
        this.storage.removeItem(key);
    }

    clear() {
        this.storage.clear();
    }
}

export const local = new Wrapper(window.localStorage);
